<template>
    <app-layout title="Nafacturatie">
        <template #header>
            <page-title :title="'Nafacturatie ' + postInvoice.request.reference" />
        </template>

        <template #pageContent>
            <Form @submitted="postForm">
                <div class="w-4/6 grid grid-cols-2 gap-6">
                    <div class="flex flex-col">
                        <Input
                            type="text"
                            label="Nummer"
                            name="reference"
                            :required="true"
                            v-model="form.reference"
                            :error="form.errors.reference"
                            layout="vertical"
                        />
                        <Select
                            label="Status nafacturatie"
                            name="status"
                            :required="true"
                            :options="statusOptions"
                            v-model="form.status"
                            :error="form.errors.status"
                            layout="vertical"
                        />
                        <Textarea
                            label="Extra info boekhouding"
                            name="info_accounting"
                            v-model="form.info_accounting"
                            :error="form.errors.info_accounting"
                            layout="vertical"
                        />
                        <Button
                            buttonClass="save"
                            title="Opslaan"
                            text="Opslaan"
                            type="submit"
                            class="self-end"
                            :loading="form.processing"
                        />
                    </div>
                    <div>
                        <Table class="border-0">
                            <tr>
                                <Td class="border-0">Aanvraag:</Td>
                                <Td class="border-0">{{ postInvoice.request.reference }}</Td>
                            </tr>
                            <tr>
                                <Td class="border-0">Status:</Td>
                                <Td class="border-0">{{ statusses[postInvoice.request.status] }}</Td>
                            </tr>
                            <tr>
                                <Td class="border-0">Extra info asbest:</Td>
                                <Td class="border-0">{{ postInvoice.info_asbestos }}</Td>
                            </tr>
                            <tr>
                                <Td class="border-0">Bijlage:</Td>
                                <Td class="border-0">
                                    <a
                                        :href="'/accountancy/post-invoices/' + postInvoice.id + '/post-invoice/download-attachment'"
                                        v-if="postInvoiceAttachment"
                                    >
                                        {{ postInvoiceAttachment.file }}
                                    </a>
                                </Td>
                            </tr>
                        </Table>
                    </div>
                </div>
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'
import Textarea from '@/Components/Textarea.vue'

import store from '@/store'
import {useForm} from "@inertiajs/inertia-vue3";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        Form,
        Input,
        Select,
        Textarea,
    },
    props: [
        'postInvoice',
        'postInvoiceAttachment',
        'availableStatusses',
        'statusses',
    ],
    setup (props)
    {
        let statusOptions = {}

        // Object.entries(props.availableStatusses).forEach(function(status, name) {
        for (const [status, value] of Object.entries(props.availableStatusses)) {
            statusOptions[status] = value
        }

        const form = useForm({
            reference: props.postInvoice.reference,
            status: props.postInvoice.status,
            info_accounting: props.postInvoice.info_accounting,
        })

        function postForm()
        {
            form.post(route('accountancy.post-invoices.update-post-invoice', { 'postInvoice': props.postInvoice.id }))
        }

        return {
            state: store.state,
            ...store,
            statusOptions,
            form,
            postForm,
        }
    },
}

</script>

<style scoped>
tr.nohover:hover td  {
    background: none;
}
</style>
